<template>
  <div class="data-calon-container">
    <Forbidden v-if="getUserRole[getUserRole.length - 1].role_id == 0" routerPath="notLogin" />
    <Forbidden
      v-else-if="getUserRole[getUserRole.length - 1].role_id != userRole.STUDENT_CANDIDATE"
      routerPath="incorrectRole"
    />
    <Forbidden v-else-if="!getParticipantSelectionPeriodOpened" routerPath="notInPeriod" />
    <div v-else class="data-calon-container vector-background col v-center">
      <h3 class="header-title">Data Calon Peserta</h3>
      <div class="table-container">
        <b-row
          v-if="dataCalon.length == 0 && dataEvaluatedCalon.length == 0"
          align-v="center"
          align-h="center"
        >
          <p class="text-center">Tidak ada peserta untuk dinilai</p>
        </b-row>
        <div v-else class="table-wrapper">
          <table id="table-calon-peserta" aria-describedby="table-calon-peserta">
            <tr>
              <th scope="col">Nama</th>
              <th scope="col">Username</th>
              <th scope="col">Rekaman</th>
              <th scope="col">Keterangan</th>
            </tr>
            <tr v-for="data in dataCalon" :key="data.id">
              <td
                @click="showRegistrationData(data)"
                class="name"
                :class="checkEvaluatedStudent(data)"
              >{{ data.display_name }}</td>
              <td :class="checkEvaluatedStudent(data)">{{ data.username }}</td>
              <td :class="checkEvaluatedStudent(data)">
                <vue-audio :file="data.registration_data.recording" />
              </td>
              <td :class="checkEvaluatedStudent(data)">
                <button class="btn" @click="toggleModal(data)">Nilai</button>
              </td>
              <b-modal v-model="showRegistrationModal" hide-footer>
                <RegistrationData
                  :getRegistrationData="studentRegistrationData.registration_data"
                  :getFullname="studentRegistrationData.display_name"
                />
              </b-modal>
            </tr>
          </table>
          <div class="indicator-container">
            <div class="indicator"></div>
            <p class="indicator-note">Sudah dinilai</p>
          </div>
        </div>
      </div>
      <b-modal
        v-model="isModal"
        class="modal"
        size="sm"
        hide-footer
        centered
        title="Seleksi Peserta"
      >
        <h4 class="student-name" v-if="studentModal !== null">{{ studentModal.display_name }}</h4>
        <b-form @submit.stop.prevent="handleSubmit(studentModal)">
          <b-row>
            <b-col>
              <b-form-group
                id="harakatMistake-group"
                label="Kesalahan Huruf/Harakat"
                label-for="harakatMistake"
              >
                <b-form-select
                  id="harakatMistake"
                  v-model="form.harakatMistake"
                  :options="scoreOption"
                  required
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>Pilih Opsi</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="madMistake-group"
                label="Kesalahan Panjang Pendek"
                label-for="madMistake"
              >
                <b-form-select
                  required
                  id="madMistake"
                  v-model="form.madMistake"
                  :options="scoreOption"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>Pilih Opsi</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="gunnahMistake-group"
                label="Kesalahan Gunnah"
                label-for="gunnahMistake"
              >
                <b-form-select
                  required
                  id="gunnahMistake"
                  v-model="form.gunnahMistake"
                  :options="scoreOption"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>Pilih Opsi</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="isLulus-group" label="Kelulusan" label-for="isLulus">
                <b-form-select id="isLulus" v-model="form.isLulus" :options="graduationOption">
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>Pilih Opsi</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="!form.isLulus">
            <b-col>
              <b-form-group
                id="levelTahsin-group"
                label="Level tahsin yang disarankan"
                label-for="levelTahsin"
              >
                <b-form-select
                  required
                  id="levelTahsin"
                  v-model="form.levelTahsin"
                  :options="levelTahsinOption"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>Pilih Opsi</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group id="note-group" label="Catatan" label-for="note">
                <b-form-textarea
                  id="note"
                  v-model="form.note"
                  placeholder="Isi catatan yang perlu diketahui murid di sini..."
                  rows="3"
                  max-rows="4"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="modal-footer">
            <b-button
              id="submit"
              type="submit"
              size="sm"
              ref="btn-submit"
              variant="none"
              class="primary mt-2 mx-auto"
            >Submit</b-button>
          </div>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import User from "@/services/User";
import Forbidden from "@/views/Forbidden.vue";
import RegistrationData from "@/components/RegistrationData.vue";
import { UserRole, TermStatus } from "@/services/StatusCode";

export default {
  name: "DataCalonPeserta",
  components: {
    Forbidden,
    RegistrationData
  },
  data() {
    return {
      dataCalon: [],
      dataEvaluatedCalon: [],
      isModal: false,
      studentModal: null,
      scoreOption: [
        { value: 1, text: "1 Kesalahan" },
        { value: 2, text: "2 Kesalahan" },
        { value: 3, text: "3 Kesalahan" },
        { value: 4, text: "4 Kesalahan" },
        { value: 5, text: "5 Kesalahan" },
        { value: 6, text: "6 Kesalahan" },
        { value: 7, text: "7 Kesalahan" },
        { value: 8, text: "8 Kesalahan" },
        { value: 9, text: "9 Kesalahan" },
        { value: 10, text: "10 Kesalahan" },
        { value: 11, text: "Lebih dari 10 Kesalahan" }
      ],
      graduationOption: [
        { value: true, text: "Lulus" },
        { value: false, text: "Tidak Lulus" }
      ],
      levelTahsinOption: [
        { value: 1, text: "Level 1" },
        { value: 2, text: "Level 2" }
      ],
      form: {
        harakatMistake: "",
        madMistake: "",
        gunnahMistake: "",
        isLulus: false,
        levelTahsin: 0,
        note: ""
      },
      showRegistrationModal: false,
      studentRegistrationData: "",
      userRole: UserRole,
      termStatus: TermStatus
    };
  },
  created() {
    User.getLatestPeriod(process.env.VUE_APP_URL);
    if (
      this.getUserRole[this.getUserRole.length - 1].role_id != 0 &&
      this.getUserRole[this.getUserRole.length - 1].role_id ==
        UserRole.STUDENT_CANDIDATE &&
      this.getParticipantSelectionPeriodOpened
    ) {
      this.initData();
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getPeriodId: "getPeriodId",
      getUserId: "getUserId",
      getUserRole: "getUserRole",
      getParticipantSelectionPeriodOpened: "getParticipantSelectionPeriodOpened"
    })
  },
  methods: {
    checkEvaluatedStudent(data) {
      return {
        evaluated: this.dataEvaluatedCalon.includes(data)
      };
    },
    showRegistrationData(data) {
      this.showRegistrationModal = true;
      this.studentRegistrationData = data;
    },
    toggleModal(dataStudent) {
      this.isModal = !this.isModal;
      this.studentModal = dataStudent;
      User.getScoreCandidate(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getPeriodId,
        dataStudent
      ).then(response => {
        this.form.harakatMistake = response["harakat_mistake"];
        this.form.madMistake = response["mad_mistake"];
        this.form.gunnahMistake = response["gunnah_mistake"];
        this.form.isLulus = response["is_passed"];
        this.form.levelTahsin = response["tahsin_level"];
        this.form.note = response["note"];
      });
    },
    handleSubmit(dataStudent) {
      User.sendScoreCandidate(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getPeriodId,
        this.form,
        dataStudent
      ).then(async () => {
        this.initData();
        this.isModal = false;
      });
    },
    async getDataCalon() {
      await User.getCandidateData(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getPeriodId
      ).then(response => {
        this.dataCalon = response.candidates;
      });
    },
    async getDataNilaiCalon() {
      await User.getAllCandidateScore(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getPeriodId
      ).then(response => {
        this.dataCalon.push(...response.candidates);
        this.dataEvaluatedCalon = response.candidates;
      });
    },
    async initData() {
      await this.getDataCalon();
      await this.getDataNilaiCalon();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/form.scss";
@import "@/styles/reusable/table.scss";

.data-calon-container {
  min-height: inherit;
}

.student-name {
  text-align: center;
  margin-bottom: $gap-sm-4;
}

.level-tahsin {
  margin-top: $gap-sm-4;
}

.score {
  align-items: center;
  justify-content: center;
  text-align: center;
}

.evaluated {
  background: rgba($color: $primary, $alpha: 0.4);
}

.indicator-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .indicator {
    background: rgba($color: $primary, $alpha: 0.4);
    border-radius: 50%;
    height: 18px;
    width: 18px;
    margin: $gap-sm-2;
  }
}

.graduation {
  text-align: center;
  margin-bottom: $gap-sm-4;

  .primary {
    color: $primary;
  }

  .danger {
    color: $danger;
  }
}

.note {
  margin-top: $gap-m-1;
  label {
    font-weight: bold;
    margin-bottom: $gap-sm-1;
  }

  p {
    word-break: break-all;
    white-space: pre-wrap;
  }
}

.header-title {
  text-align: center;
  color: #000;
  font-weight: bold;
  margin-top: $gap-m-2;
  margin-bottom: $gap-m-2;
}

.hero-message {
  max-width: 20rem;
}

#table-calon-peserta {
  .name {
    cursor: pointer;

    &:hover {
      mix-blend-mode: difference;
      color: white;
    }
  }
}
</style>
